import { useTranslation } from 'react-i18next';
export var useLabelTextMap = function (keys) {
    var t = useTranslation().t;
    var labels = new Map();
    for (var _i = 0, _a = Object.entries(keys); _i < _a.length; _i++) {
        var _b = _a[_i], translation_key = _b[1];
        labels.set(translation_key, t(translation_key));
    }
    return labels;
};
